// Helper minimal de lecture de fichier CSV côté client.
// Le parsing et la détection de doublons sont faits côté serveur (POST /api/import/historique/csv/preview).

export function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (): void => {
      const result = reader.result;
      if (typeof result === 'string') resolve(result);
      else reject(new Error('Lecture du fichier impossible'));
    };
    reader.onerror = (): void => {
      reject(new Error('Erreur lecture fichier'));
    };
    reader.readAsText(file, 'utf-8');
  });
}
